// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"424f35487dcde9be7ffa","655":"39a3cd152e419e683c78"}[chunkId] + ".js";
};